var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUploadDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5615 20.9996V13.001",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2334 16.3338L11.5639 13.001L14.8945 16.3338",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.225 14.3317H17.2242C19.0884 14.3349 20.7453 13.1437 21.3372 11.3747C21.9291 9.60583 21.3231 7.65639 19.8328 6.53563C18.3426 5.41487 16.3028 5.37443 14.7694 6.43525C14.1512 3.14189 11.1858 0.819724 7.84256 1.011C4.49933 1.20228 1.81772 3.84754 1.57871 7.18994C1.3397 10.5323 3.6176 13.5327 6.89955 14.1984",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadDark);
export default __webpack_public_path__ + "static/media/cloud-upload-dark.ef1513996da30728f2189147dbe1f3a0.svg";
export { ForwardRef as ReactComponent };